import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-on-hold-loading',
  templateUrl: './on-hold-loading.component.html',
  styleUrls: ['./on-hold-loading.component.css']
})
export class OnHoldLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
